import React from 'react';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter, Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { messages } from 'app/config/constants';
import './profile.scss';
export interface IMessageModalConfirmProps {
  showModalConfirm: boolean;
  message: string;
  invokeCancel: Function;
  invokeAgree: Function;
}

class MessageModalConfirm extends React.Component<IMessageModalConfirmProps> {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <Modal isOpen={this.props.showModalConfirm} centered={window.location === window.parent.location}>
          {/* <ModalHeader >Modal title</ModalHeader> */}
          <ModalBody>
            <label className="string-modal-confirm">
              [ {this.props.message} ] đã được xác minh, sau khi cập nhật sẽ chuyển về trạng thái chưa xác minh thông tin, bạn có chắc chắn
              muốn cập nhật?
            </label>
          </ModalBody>
          <ModalFooter>
            <Button className="btn-register-white" onClick={this.props.invokeCancel}>
              Không
            </Button>
            <Button className="btn-register" onClick={this.props.invokeAgree}>
              Có
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default MessageModalConfirm;
